/**
 * Constants for Interview Management
 * Centralizes all magic strings and configuration values
 */

// Interview Status Types
export const INTERVIEW_STATUS = {
  SCHEDULED: 'scheduled',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  RESCHEDULED: 'rescheduled'
};

// Interview Tab Configuration
export const INTERVIEW_TABS = [
  { id: 'scheduled', label: 'Scheduled', status: INTERVIEW_STATUS.SCHEDULED },
  { id: 'completed', label: 'Completed', status: INTERVIEW_STATUS.COMPLETED },
  { id: 'cancelled', label: 'Cancelled', status: INTERVIEW_STATUS.CANCELLED },
  { id: 'all', label: 'All Interviews', status: null }
];

// Filter Options
export const FILTER_OPTIONS = {
  DATE_RANGE: {
    ALL: 'all',
    TODAY: 'today',
    THIS_WEEK: 'this_week',
    THIS_MONTH: 'this_month',
    PAST_DUE: 'past_due'
  },
  INTERVIEW_TYPE: {
    ALL: 'all',
    PHONE: 'phone',
    VIDEO: 'video',
    IN_PERSON: 'in_person'
  },
  HIRING_STATUS: {
    ALL: 'all',
    PENDING: 'pending',
    HIRED: 'hired',
    REJECTED: 'rejected'
  },
  SORT_BY: {
    DATE_ASC: 'date_asc',
    DATE_DESC: 'date_desc',
    NAME_ASC: 'name_asc',
    NAME_DESC: 'name_desc'
  }
};

// View Modes
export const VIEW_MODES = {
  GRID: 'grid',
  LIST: 'list',
  CALENDAR: 'calendar'
};

// Action Types
export const INTERVIEW_ACTIONS = {
  SCHEDULE: 'schedule',
  RESCHEDULE: 'reschedule',
  CANCEL: 'cancel',
  COMPLETE: 'complete',
  MESSAGE: 'message',
  UPDATE_STATUS: 'update_status'
};

// Modal Types
export const MODAL_TYPES = {
  SCHEDULE: 'schedule',
  FEEDBACK: 'feedback',
  CONTACT: 'contact',
  DECISION: 'decision',
  TIME_SLOT_MANAGER: 'time_slot_manager',
  INTERVIEW_DETAILS: 'interview_details'
};

// Performance Configuration
export const PERFORMANCE_CONFIG = {
  DEBOUNCE_DELAY: {
    SEARCH: 300,
    FILTER: 200,
    REALTIME_UPDATE: 500
  },
  CACHE_DURATION: {
    INTERVIEWS: 5 * 60 * 1000, // 5 minutes
    CANDIDATES: 10 * 60 * 1000, // 10 minutes
    TIME_SLOTS: 30 * 60 * 1000 // 30 minutes
  },
  PAGINATION: {
    DEFAULT_PAGE_SIZE: 20,
    MAX_PAGE_SIZE: 100
  }
};

// Default Filter State
export const DEFAULT_FILTERS = {
  dateRange: FILTER_OPTIONS.DATE_RANGE.ALL,
  interviewType: FILTER_OPTIONS.INTERVIEW_TYPE.ALL,
  hiringStatus: FILTER_OPTIONS.HIRING_STATUS.ALL,
  searchQuery: '',
  sortBy: FILTER_OPTIONS.SORT_BY.DATE_DESC
};

// Error Messages
export const ERROR_MESSAGES = {
  UNAUTHORIZED: 'You do not have permission to perform this action.',
  INTERVIEW_NOT_FOUND: 'The selected interview could not be found.',
  NETWORK_ERROR: 'Network error occurred. Please check your connection.',
  VALIDATION_ERROR: 'Please check your input and try again.',
  GENERIC_ERROR: 'An unexpected error occurred. Please try again.',
  LOADING_ERROR: 'There was a problem loading your interviews. Please try again.'
};

// Success Messages
export const SUCCESS_MESSAGES = {
  INTERVIEW_SCHEDULED: 'The interview has been successfully scheduled.',
  INTERVIEW_RESCHEDULED: 'The interview has been successfully rescheduled.',
  INTERVIEW_CANCELLED: 'The interview has been successfully cancelled.',
  INTERVIEW_COMPLETED: 'The interview has been marked as completed and your feedback has been saved.',
  STATUS_UPDATED: 'Interview status has been updated successfully.',
  HIRING_STATUS_UPDATED: 'The hiring status has been updated successfully.'
};

// Validation Rules
export const VALIDATION_RULES = {
  INTERVIEW_TITLE: {
    MIN_LENGTH: 3,
    MAX_LENGTH: 100
  },
  NOTES: {
    MAX_LENGTH: 1000
  },
  DURATION: {
    MIN: 15, // minutes
    MAX: 480 // 8 hours
  }
};

// Real-time Channel Names
export const CHANNELS = {
  INTERVIEW_CHANGES: 'interview-changes',
  NOTIFICATIONS: 'notifications'
};